import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import warning from 'warning';
import withThemeConfig from '../_utils/withThemeConfig';

var Body = function (_React$Component) {
  _inherits(Body, _React$Component);

  var _super = _createSuper(Body);

  function Body(props) {
    var _this;

    _classCallCheck(this, Body);

    _this = _super.call(this, props);
    var compact = props.compact,
        themeConfig = props.themeConfig;
    warning(compact === undefined || themeConfig.compact === undefined, "Vous ne devriez pas d\xE9finir la prop. `compact` alors que celle-ci a " + "d\xE9j\xE0 \xE9t\xE9 d\xE9finie sur le component `<Theme>`, la prop. va \xEAte ignor\xE9.");
    return _this;
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          themeConfig = _this$props.themeConfig;
      var compact = this.props.compact;

      if (themeConfig.compact !== undefined) {
        compact = themeConfig.compact;
      }

      var _className = classnames('Body', {
        'Body--compact': !!compact
      });

      return React.createElement("div", {
        className: _className
      }, children);
    }
  }]);

  return Body;
}(React.Component);

Body.defaultProps = {
  compact: undefined,
  children: undefined
};
export default withThemeConfig(Body);